import { createFileRoute } from '@tanstack/react-router';
import Logistics from 'src/components/0500_logistics/dystopia_rising';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/logistics',
)({
  component: Logistics,
});
